// @flow

import Cookies from "js-cookie";

export function getWishlistProductIds(): number[] {
  const productIds: ?string = Cookies.get("reece-product-compare");
  if (productIds) {
    return productIds.split(",").map(productId => parseInt(productId, 10));
  } else {
    return [];
  }
}

export function removeWishListProduct(productIdToRemove: number): void {
  const productIds = getWishlistProductIds();

  const productIdArray = productIds.filter(id => id !== productIdToRemove);

  Cookies.set("reece-product-compare", productIdArray.join(","));

  window.reece.wishlist.updateWishlistCount();
}

export function getPostCode(): ?string {
  const userLocation = Cookies.get("reece-user-location");
  if (userLocation) {
    return JSON.parse(decodeURIComponent(userLocation)).postCode;
  } else {
    return null;
  }
}
